// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lairon: PokeData = {
  "id": 305,
  "name": "lairon",
  "height": 9,
  "weight": 1200,
  "base_experience": 151,
  "types": [
    PokeType.STEEL,
    PokeType.ROCK
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "roar",
    "harden",
    "rock-slide",
    "protect",
    "mud-slap",
    "iron-tail",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "iron-head",
    "autotomize",
    "heavy-slam"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "rock-slide",
    "protect",
    "mud-slap",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "metal-burst",
    "metal-rush",
    "power-siphon",
    "seismic-toss",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 151,
    "item": null,
    "species": [
      {
        "name": "aron",
        "order": 330,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lairon",
        "order": 331,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 304,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "aggron",
        "order": 332,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 305,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 77.5,
    "speed": 40,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
